import dynamic from 'next/dynamic';

export const VehicleListRefreshButtonV2 = dynamic(
	() => import('./VehicleListRefreshButtonV2').then((mod) => mod.VehicleListRefreshButtonV2),
	{ ssr: false },
);
